<template>
  <div class="overview-card">
    <div class="d-flex align-items-center">
      <h3 class="text-neutral-700">{{ title }}</h3>
      <div class="flex-fill" />
      <div class="d-flex align-items-end gap-1">
        <span class="functional-2 text-neutral-500">{{ prefix }}</span>
        <h3 :class="`text-${color}`">{{ value }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    },
    prefix: {
      type: String,
      default: "R$"
    },
    color: {
      type: String,
      default: "neutral-700"
    }
  }
};
</script>

<style lang="scss" scoped>
.overview-card {
  border-radius: var(--4-8, 4px);
  border: 1px solid var(--Semantic-Neutral-100, #d7d7d7);
  background: var(--Surface-Cumulative-plus4, rgba(255, 255, 255, 0.16));
  backdrop-filter: blur(12px);

  padding: 20px;
  @media screen and (max-width: 991px) {
    padding: 12px 16px;
  }
}
</style>
